import gql from 'graphql-tag';
import includes from 'lodash/includes';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { ADMIN_SESSIONS } from '../../routes';
import AdminOwners from '../AdminOwners';
import AdminRoute from '../AdminRoute';
import AdminSessionChart from '../AdminSessionChart';
import AdminSessionDatePickers from '../AdminSessionDatePickers';
import AdminSessionGames from '../AdminSessionGames';
import Checkbox from '../Checkbox';
import Loader from '../Loader';
import './styles.scss';
import UpdateSessionDates from '../../mutations/UpdateSessionDates';

export class GamesFilters extends Component {
	render() {
		const { clickedAnonymous, anonymous } = this.props;

		return (
			<div className="AdminSessionDetail-filters">
				<Checkbox
					clicked={clickedAnonymous}
					checked={anonymous}
					value="anonymous"
					name="anonymous-check">
					Anonymous
				</Checkbox>
			</div>
		);
	}
}

const SESSION_QUERY = gql`
	query sessionQuery($sessionID: ID!) {
		user {
			id
			teams
			session(sessionID: $sessionID) {
				id
				name
				date
				teamsCount
				creator {
					id
				}
				coordinatorKpis
				owners {
					id
					username
					password
					firstName
					lastName
					roles
				}
				startDate
				endDate
			}
		}
	}
`;

class AdminSessionsDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showForm: false,
			anonymous: false
		};
		this.onClickAdd = this.onClickAdd.bind(this);
		this.onToggleAnonymous = this.onToggleAnonymous.bind(this);
	}

	getAvailableOwners(data) {
		const { users } = this.props;
		const { session } = data.user;

		return users.filter(
			user =>
				(includes(user.roles, 'admin') || includes(user.roles, 'instructor')) &&
				!includes(session.owners.map(o => o.id), user.id)
		);
	}

	getOwners(data) {
		const { session } = data.user;
		return session.owners.map(owner => {
			const { id, roles } = owner;
			const name = `${owner.firstName} ${owner.lastName}`;
			const creator = owner.id === session.creator.id;
			const backgroundColor = creator ? '#f5a623' : 'transparent';
			const border = creator ? 'none' : '1px solid #EEE';

			const squareBox = (
				<div
					style={{
						width: '12px',
						height: '12px',
						borderRadius: '2px',
						backgroundColor,
						border,
						margin: '0 5px 0 0'
					}}
				/>
			);

			const creatorColumn = (
				<div style={{ display: 'flex', alignItems: 'center' }}>{squareBox}</div>
			);

			return {
				id,
				name,
				creator: creatorColumn,
				roles: roles.join('<br/>'),
				actions: ''
			};
		});
	}

	onClickAdd() {
		this.setState({
			showForm: !this.state.showForm
		});
	}

	onToggleAnonymous() {
		this.setState({ anonymous: !this.state.anonymous });
	}
	
	onChangeDates(startDate, endDate, sessionID, mutation){
		mutation({
			variables: {
				startDate,
				endDate,
				sessionID
			}
		})
	}

	render() {
		const { anonymous } = this.state;

		const { match, sessions, users } = this.props;
		const sessionID = match.params.sessionID;
		return (
			<Query
				query={SESSION_QUERY}
				fetchPolicy={'cache-and-network'}
				variables={{
					sessionID
				}}>
				{({ data }) => {
					if (!data.user) {
						return <Loader />;
					}
					const { session } = data.user;
					console.log(session)
					const { coordinatorKpis } = session;
					const chartData = anonymous
						? coordinatorKpis.map((coordinator, index) => ({
							...coordinator,
							label: `TEAM ${index}`
						}))
						: coordinatorKpis;
					return (
						<div className="AdminSessionDetail">
							<AdminRoute
								backRoute={ADMIN_SESSIONS}
								title="Session"
								subTitle={`Session - ${session ? session.name : ''}`}
								icon="sessionsColor"
								buttonInactive={true}
								buttonTheme="orange"
								buttonCta="Add session"
								buttonClicked={this.onClickAdd}
								filters={
									<GamesFilters
										clickedAnonymous={this.onToggleAnonymous}
										anonymous={anonymous}
									/>
								}>
								<UpdateSessionDates>
									{updateSessionDatesMutation => (
										<AdminSessionDatePickers 
											sessionID={session.id} 
											onChange={updateSessionDatesMutation} 
											startDate={session.startDate}
											endDate={session.endDate}
										/>
									)}
								</UpdateSessionDates>
								<AdminSessionChart data={chartData} />
								<AdminOwners
									owners={this.getOwners(data)}
									availableOwners={this.getAvailableOwners(data)}
									session={session}
								/>
								<AdminSessionGames
									teams={data.user.teams}
									sessions={sessions}
									users={users}
									sessionID={sessionID}
								/>
							</AdminRoute>
						</div>
					);
				}}
			</Query>
		);
	}
}

export default AdminSessionsDetails;
